<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
			<v-row>
				<v-col cols="12" md="6">
					<div>
						<div class="mb-1">تاریخ شروع وام*</div>
						<date-picker ref="startDate" v-model="localData.startDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" auto-submit :rules="[() => !!localData.startDate || 'تاریخ شروع را به صورت صحیح وارد کنید']" />
					</div>
				</v-col>
				<v-col cols="12" md="6">
					<div class="mb-1">سررسید واریز به حساب مشتری</div>
					<date-picker v-model="localData.depositChargeDueDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" auto-submit />
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="6">
					<v-combobox v-model="localData.memberModel" clearable required :items="members" label="عضو*" single-line return-object :error-messages="errorMessages" item-text="fullName" item-value="id" :rules="[() => !!localData.memberModel || 'مشتری را انتخاب کنید']" />
				</v-col>
				<v-col cols="12" md="6">
					<v-select v-model="localData.loanModel" clearable required single-line return-object :items="loans" label="وام*" item-text="title" item-value="id" :error-messages="errorMessages" :rules="[() => !!localData.loanModel || 'وام را انتخاب کنید']" @change="loanOnchange" />
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="6">
					<v-text-money ref="amount" v-model="localData.amount" label="*مبلغ" :error-messages="errorMessages" :rules="[() => localData.amount > 0 || 'مبلغ وام را به صورت صحیح وارد کنید']" required @blur="() => { calcInstallment(); calcAgentShare() }" />
				</v-col>
				<v-col cols="12" md="6">
					<v-text-field ref="month" v-model="localData.month" label="تعداد اقساط*" :error-messages="errorMessages" :rules="[() => Number(localData.month) > 0 || 'تعداد اقساط را به صورت صحیح وارد کنید']" required @blur="() => { calcInstallment(); calcAgentShare() }" />
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="6">
					<v-text-field ref="monthGap" v-model="localData.monthGap" label="فاصله اقساط*" :error-messages="errorMessages" :rules="[() => Number(localData.monthGap) > 0 || 'فاصله اقساط باید بیشتر از صفر باشد']" required @blur="calcInstallment" />
				</v-col>
				<v-col cols="12" md="6">
					<v-text-money ref="installment" v-model="localData.installment" label="*مبلغ هر قسط" :error-messages="errorMessages" :rules="[() => !!localData.installment > 0 || 'مبلغ هر قسط را به صورت صحیح وارد کنید']" required />
					<small>{{ installmentHint }}</small>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="6">
					<v-text-money ref="preDepositAmount" v-model="localData.preDepositAmount" label="مبلغ پیش پرداخت" :error-messages="errorMessages" :rules="[() => Number(localData.preDepositAmount) >= 0 || 'مبلغ پیش پرداخت نمی تواند کمتر از صفر باشد']" required />
				</v-col>
				<v-col cols="12" md="6">
					<v-text-field ref="secondarycode" v-model="localData.secondaryCode" label="شماره پرونده فرعی" />
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12">
					<v-textarea v-model="localData.description" auto-grow outlined color="deep-purple" label="توضیحات" rows="1"></v-textarea>
					<small>*فیلدهای ستاره دار ضروری هستند.</small>
				</v-col>
			</v-row>


			<v-card color="#eee" class="mb-6 pr-3" v-if="localData.id !== local_emptyId">
				<v-row>
					<v-col cols="12" md="12" class="d-flex justify-center">
						<v-switch :disabled="!checkPermission('Chackout_Loan')" v-model="localData.isCheckouted" label="وام تسویه شده است" color="secondary" :value="true" hide-details></v-switch>
					</v-col>
				</v-row>
				<v-row v-if="localData.isCheckouted">
					<v-col cols="12" md="12" class="d-flex justify-center">
						<div>
							<div>تاریخ تسویه</div>
							<date-picker :disabled="!checkPermission('Chackout_Loan')" ref="checkoutDate" v-model="localData.checkoutDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" auto-submit />
						</div>
					</v-col>
				</v-row>
			</v-card>

			<v-card color="#eee" class="mb-6 pr-3">
				<v-row>
					<v-col cols="12" md="12" class="d-flex justify-center">
						<v-switch v-model="differentProfitPercent" label="تغییر درصد بهره برای این پرونده" color="secondary" :value="true" hide-details @change="test"></v-switch>
					</v-col>
				</v-row>
				<v-row v-if="differentProfitPercent" class="justify-center">
					<v-col cols="12" md="6" class="">
						<v-card color="#ddd" class="pa-2 mb-2" elevation="0">
							<small class="grey--text">درصد پیش فرض وام: {{ localData.loanModel.profitPercent }}</small>
						</v-card>
						<v-text-field type="number" v-model="localData.customProfitPercent" label="درصد بهره جدید" :error-messages="errorMessages" :rules="[() => Number(localData.customProfitPercent) >= 0 || 'درصد بهره را به صورت صحیح وارد کنید']" required @blur="() => { calcInstallment(); calcAgentShare() }" />
					</v-col>
				</v-row>
			</v-card>


			<v-card color="#eee" class="mb-6 px-3" v-if="checkActivePart('agent')">
				<v-row>
					<v-col cols="12" md="12" class="d-flex justify-center">
						<v-switch v-model="hasAgent" label="وام دارای نماینده است" color="secondary" :value="true" hide-details></v-switch>
					</v-col>
				</v-row>
				<v-row v-show="hasAgent">
					<v-col cols="12" md="6">
						<div v-if="localData.agentModel" style="position: absolute;">نماینده</div>
						<v-combobox v-model="localData.agentModel" clearable :items="agents" label="نماینده" single-line return-object :error-messages="errorMessages" item-text="businessName" item-value="id" @change="calcAgentShare" />
					</v-col>
					<v-col cols="12" md="6">
						<v-text-money v-model="localData.agentPrice" label="سهم نماینده" :error-messages="errorMessages" :rules="[() => Number(localData.agentPrice) >= 0 || 'سهم نماینده نمی تواند کمتر از 0 باشد']" />
					</v-col>
					<v-col cols="12" md="6">
						<div class="mb-1">تاریخ سررسید واریز به نماینده</div>
						<date-picker v-model="localData.agentDueDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" auto-submit />
						<div><small class="blue--text" @click="offDates" style="cursor:pointer">تعطیلی های تقویم</small></div>
					</v-col>
				</v-row>
			</v-card>

			<v-card color="#eee" class="mb-6 px-3" v-if="checkActivePart('contact')">
				<v-row>
					<v-col cols="12" md="12" class="d-flex justify-center">
						<v-switch v-model="hasContact" @change="hasContactChanged" label="شامل سهم طرف حساب ها" color="secondary" :value="true" hide-details></v-switch>
					</v-col>
				</v-row>
				<div v-show="hasContact" class="mb-2 mt-5">
					<v-card v-for="(userLoanContact, index) in localData.userLoanContacts" :key="userLoanContact.id + index" class="mb-3 pa-3" elevation="0" style="border: 1px solid c">
						<v-row class="d-flex">
							<v-col cols="12" md="12" class="py-0 my-0 text-center" style="border-bottom: 1px dashed #eee;">
								<div class="text-h4">{{ userLoanContact.contact.fullName }}</div>
								<div class="text-h6 grey--text"><span>{{ userLoanContact.contact.businessName }}</span></div>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="4" class="py-0 pt-2 my-0">
								<v-text-field v-model="userLoanContact.share" label="مبلغ سهم" :error-messages="errorMessages" :rules="[(val) => val >= 0 || 'سهم طرف حساب را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="7">
								<div class="mb-1">سررسید واریز به شخص</div>
								<date-picker v-model="userLoanContact.dueDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" auto-submit />
							</v-col>
							<v-col cols="1" md="1" class="my-0 py-0 d-flex align-center align-left">
								<v-btn @click="removeContact(userLoanContact, index)" class="" small icon dark title="حذف">
									<v-icon dark color="red">
										mdi-close
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-card>
				</div>
			</v-card>

			<v-card color="#eee" class="mb-3 px-3" v-if="checkActivePart('sponsoreDueDate')">
				<v-row>
					<v-col cols="12" md="12" class="d-flex justify-center">
						<v-switch v-model="hasSponsoreDueDate" @change="hasSponsoreDueDateChanged" label="شامل سررسید اسپانسر" color="secondary" :value="true" hide-details></v-switch>
					</v-col>
				</v-row>
				<div v-show="hasSponsoreDueDate" class="mb-2 mt-5">
					<v-card v-for="(sponsoreDueDate, index) in localData.userLoanSponsoreDueDates" :key="sponsoreDueDate.id + index" class="mb-3 pa-3" elevation="0" style="border: 1px solid c">
						<v-row>
							<v-col cols="10" md="10" class="py-0 pt-2 my-0">
								<v-row>
									<v-col cols="12" md="5" class="py-1">
										<v-text-field v-model="sponsoreDueDate.amount" label="مبلغ" :error-messages="errorMessages" :rules="[() => sponsoreDueDate.amount >= 0 || 'مبلغ را به صورت صحیح وارد کنید']" required />
									</v-col>
									<v-col cols="12" md="5" class="py-1">
										<div class="mb-1">سررسید</div>
										<date-picker class="small" v-model="sponsoreDueDate.dueDate" format="YYYY-MM-DDTHH:mm:ss" display-format="jDD jMMMM jYYYY" :error-messages="errorMessages" auto-submit />
									</v-col>
									<v-col cols="12" md="2" class="pt-8 px-0">
										<v-checkbox color="secondary" class="small" v-model="sponsoreDueDate.isCheckouted" style="display:inline" :label="'تسویه؟'" />
									</v-col>
									<v-col cols="12" md="12" class="py-0">
										<v-text-field v-model="sponsoreDueDate.description" label="توضیحات" :error-messages="errorMessages" />
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="2" md="2" class="my-0 py-0 d-flex align-center justify-end">
								<v-btn @click="removeSponsoreDueDate(sponsoreDueDate, index)" class="" small icon dark title="حذف">
									<v-icon dark color="red">
										mdi-close
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-card>
					<div class="text-center mt-5 pb-5">
						<v-btn class="mx-auto" color="secondary" dark @click="addSponsoreDueDate" small>
							<v-icon dark>
								mdi-plus-circle-outline
							</v-icon>
							افزودن سررسید جدید
						</v-btn>
					</div>
				</div>
			</v-card>

			<v-card-actions>
				<v-spacer />
				<v-btn @click="$emit('callbck', false)">
					بستن
				</v-btn>
				<v-btn color="blue" dark :loading="submitLoading" type="submit">
					ذخیره
				</v-btn>
			</v-card-actions>
		</v-form>

		<v-dialog v-model="offDatesDialog" scrollable max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت تعطیلی های تقویم</span></div>
					<v-spacer />
					<v-btn @click="offDatesDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<OffDates v-if="offDatesDialog" @callbck="offDatesDialog = false" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import { emptyId } from '@/util/emptyId'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import { get, call } from 'vuex-pathify'
	import { cloneDeep } from 'lodash'

	export default {
		name: 'LoanInstallmentsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			OffDates: () => import('@/components/forms/OffDates'),
			'date-picker': VuePersianDatetimePicker,
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				differentProfitPercent: false,
				offDatesDialog: false,
				local_emptyId: emptyId,
				manualInput: false,
				installmentHint: '',
				errorMessages: '',
				localData: {},
				loans: [],
				members: [],
				agents: [],
				originalUserLoanContacts: [],
				submitLoading: false,
				hasAgent: false,
				hasContact: false,
				hasSponsoreDueDate: false,
				tempUserLoanSponsoreDueDates: []
			}
		},
		mounted() {
			this.prepareData()
			this.loadAgents()
			this.fetchOffDates()
		},
		computed: {
			...get('appSettings', [
				'settings',
			])
		},
		methods: {
			calcOffCount: call('offDates/calcOffCount'),
			fetchOffDates: call('offDates/fetch'),
			loanOnchange() {
				this.calcAgentShare()
				if (this.hasContact)
					this.fillContacts()
			},
			async calcAgentShare() {
				if (!this.localData.agentModel) {
					this.localData.agentPrice = ''
					this.localData.agentDueDate = null
					return
				}

				let agentLoan = this.localData.agentModel?.agentLoans.find(x => x.loanId === this.localData.loanModel?.id)
				let percent = agentLoan?.percent || 0
				if (this.localData.amount)
					this.localData.agentPrice = this.localData.amount * percent / 100
				if (agentLoan?.defaultCheckoutDays) {
					var today = new Date()
					let dueDate = new Date(new Date().setDate(today.getDate() + agentLoan.defaultCheckoutDays))
					let offCount = await this.calcOffCount({ start: today, end: dueDate })
					if (offCount > 0)
						dueDate = new Date(dueDate.setDate(dueDate.getDate() + offCount))
					this.localData.agentDueDate = dueDate.toISOString()
				}

				if (this.hasContact)
					this.fillContacts()
			},
			calcInstallment() {
				if (this.manualInput || !this.localData.amount)
					return
				let monthGap = this.localData.monthGap || 1
				let payable = 0, installment = 0
				if (this.localData.loanModel.loanProfitType === 0) {
					const profitPercent = (this.localData.customProfitPercent !== null && this.localData.customProfitPercent !== undefined) ? this.localData.customProfitPercent : this.localData.loanModel?.profitPercent
					payable = ((this.localData.amount * (this.localData.month * monthGap * profitPercent)) / 100 + Number(this.localData.amount))
					installment = Math.round(payable / this.localData.month)
				}
				else {
					const principal = this.localData.amount
					const profitPercent = (this.localData.customProfitPercent !== null && this.localData.customProfitPercent !== undefined) ? this.localData.customProfitPercent : this.localData.loanModel?.profitPercent
					const monthlyInterest = profitPercent / 100 / 12
					installment = monthlyInterest
						? (principal * monthlyInterest) / (1 - Math.pow(1 + monthlyInterest, -this.localData.month))
						: principal / this.localData.month
					installment = Math.round(installment)
					payable = Math.round(installment * this.localData.month)
				}
				installment = installment - (installment % Number('1'.padEnd(this.settings.roundCountNumber + 1, '0')))
				if (this.localData.month * installment < payable) {
					if (this.settings.appendToWhichInstallment !== 0)
						this.installmentHint = `مبلغ ${payable - this.localData.month * installment} به ${this.settings.appendToWhichInstallment === 1 ? 'اولین' : 'آخرین'} قسط اضافه می گردد`
				} else
					this.installmentHint = ''
				this.localData.installment = installment
			},
			validateAllowedMonth(month) {
				if (!this.localData.loanModel?.allowedInstallments)
					return true
				if (!this.localData.loanModel.allowedInstallments.includes('['))
					return month <= Number(this.localData.loanModel.allowedInstallments)
				else
					return JSON.parse(this.localData.loanModel.allowedInstallments).map(x => x.value).includes(month)
			},
			submit() {
				if (!this.$refs.form.validate()) { return }
				if (!this.validateAllowedMonth(this.localData.month * this.localData.monthGap)) {
					toast.error("تعداد ماه بازپرداخت از حداکثر بازپرداخت تعریف شده در وام بیشتر است.")
					return
				}
				const sumContactShares = this.localData.userLoanContacts ? this.localData.userLoanContacts.reduce((accumulator, object) => {
					return accumulator + Number(object.share)
				}, 0) : 0
				if (sumContactShares > this.localData.amount) {
					toast.error('مجموع سهم طرف حساب ها نباید بیشتر از مبلغ وام باشد.')
					return
				}
				let data = cloneDeep(this.localData)
				// this.localData.startDate = this.localData.startDate.replace(' ', 'T')
				this.submitLoading = true
				if (!data.agentPrice || !this.hasAgent) {
					data.agentPrice = 0
				}
				api.post('admin/userloan/' + (this.localData.id === emptyId ? 'create' : 'edit'), data)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.$emit('callbck', true)
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: emptyId }
				}
				api.get('admin/userloan/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = response
							this.members = [this.data.memberModel]
							this.localData.memberModel = this.data.memberModel
							this.hasContact = !!this.localData.userLoanContacts?.length
							this.hasSponsoreDueDate = !!this.localData.userLoanSponsoreDueDates?.length
							this.originalUserLoanContacts = cloneDeep(this.localData.userLoanContacts)
							this.loadLoans().then(res => {
								if (this.localData.loanModel) {
									this.localData.loanModel = this.loans.find(x => x.id === this.localData.loanModel.id)
								}
							})
							if (this.localData.agentModel)
								this.hasAgent = true
							if (this.localData.customProfitPercent !== null && this.localData.customProfitPercent !== undefined)
								this.differentProfitPercent = true
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			loadLoans() {
				return api.get('admin/loan/list/true', null)
					.then(
						response => {
							this.loans = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			loadMembers() {
				api.get('admin/member/list/' + true, null)
					.then(
						response => {
							this.members = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			loadAgents() {
				api.get('admin/agent/list/', null)
					.then(
						response => {
							this.agents = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			async removeContact(item, index) {
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					if (item.id !== emptyId) {
						let i = this.localData.userLoanContacts.findIndex(x => x.id === item.id)
						if (i > -1)
							this.localData.userLoanContacts.splice(i, 1)
					} else {
						this.localData.userLoanContacts.splice(index, 1)
					}
				}
			},
			async removeSponsoreDueDate(item, index) {
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					if (item.id !== emptyId) {
						let i = this.localData.userLoanSponsoreDueDates.findIndex(x => x.id === item.id)
						if (i > -1)
							this.localData.userLoanSponsoreDueDates.splice(i, 1)
					} else {
						this.localData.userLoanSponsoreDueDates.splice(index, 1)
					}
				}
			},
			hasSponsoreDueDateChanged(e) {
				if (!e) {
					this.tempUserLoanSponsoreDueDates = _.cloneDeep(this.localData.userLoanSponsoreDueDates)
					this.localData.userLoanSponsoreDueDates = []
				} else {
					this.localData.userLoanSponsoreDueDates = this.tempUserLoanSponsoreDueDates
				}
			},
			hasContactChanged(e) {
				if (!e) {
					this.localData.userLoanContacts = []
					return
				}
				this.fillContacts()
			},
			fillContacts() {
				if (!this.localData.loanModel)
					return

				if (this.localData.id === emptyId) {
					let contacts = this.localData.loanModel.loanContacts?.length ? [...this.localData.loanModel.loanContacts] : []
					if (this.localData.agentModel && this.localData.agentModel.agentLoans.filter(x => x.contact?.id && x.loanId === this.localData.loanModel.id)) {
						for (let agloan of this.localData.agentModel.agentLoans.filter(x => x.contact?.id && x.loanId === this.localData.loanModel.id)) {
							let con = contacts.find(x => x.contact?.id === agloan.contact.id)
							if (con) {
								con.share = agloan.contactPercent
							} else {
								contacts.push({
									contact: agloan.contact,
									share: agloan.contactPercent
								})
							}
						}
					}

					this.localData.userLoanContacts = contacts.map(x => {
						return {
							id: emptyId,
							contact: x.contact,
							share: this.localData.amount * x.share / 100,
							dueDate: new Date().toISOString(),
							userLoanId: emptyId
						}
					})
				} else {
					this.localData.userLoanContacts = cloneDeep(this.originalUserLoanContacts)

					let contacts = this.localData.loanModel.loanContacts?.length ? [...this.localData.loanModel.loanContacts] : []
					if (this.localData.agentModel && this.localData.agentModel.agentLoans.filter(x => x.contact?.id && x.loanId === this.localData.loanModel.id)) {
						for (let agloan of this.localData.agentModel.agentLoans.filter(x => x.contact?.id && x.loanId === this.localData.loanModel.id)) {
							let con = contacts.find(x => x.contact?.id === agloan.contact.id)
							if (con) {
								con.share = agloan.contactPercent
							} else {
								contacts.push({
									contact: agloan.contact,
									share: agloan.contactPercent
								})
							}
						}
					}

					for (let i = 0; i < contacts.length; i++) {
						let index = this.localData.userLoanContacts.findIndex(x => x.contact.id === contacts[i].contact.id)
						if (index > -1)
							this.localData.userLoanContacts[index].share = this.localData.amount * contacts[i].share / 100
						else
							this.localData.userLoanContacts.push({
								id: emptyId,
								contact: contacts[i].contact,
								share: this.localData.amount * contacts[i].share / 100,
								dueDate: new Date().toISOString(),
								userLoanId: this.localData.id
							})
					}
				}
			},
			offDates() {
				this.offDatesDialog = true
			},
			addSponsoreDueDate() {
				this.localData.userLoanSponsoreDueDates.push({
					id: emptyId,
					amount: 0,
					dueDate: '',
					isCheckouted: false,
					description: ''
				})
			},
			test(e) {
				if (!e) {
					this.localData.customProfitPercent = null
					this.calcInstallment()
					this.calcAgentShare()
				}
			}
		},
	}
</script>
<style>
	.vpd-main.small .vpd-input-group input {
		font-size: 12px;
		max-width: 100px;
	}
</style>
